import React from "react";

export default function FamilyPage() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Family</h2>
      <p>This is where family members will go.</p>
    </div>
  );
}
